import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { useLingui } from '@lingui/react/macro';

import { BlogHeroPost } from '#features/blog/components/BlogHeroPost';
import { BlogPostPreview } from '#features/blog/components/BlogPostPreview';
import { Link } from '#features/routing';
import { Button } from '#features/ui';

type BlogPost = {
  id: string;
  title: string;
  date: string;
  previewImage: string;
  slug: string;
  tags?: string;
  ogDescription?: string;
  content?: string;
};

type BlogPostsProps = {
  posts: BlogPost[];
};

export const BlogPosts = ({ posts }: BlogPostsProps) => {
  const { t } = useLingui();

  const heroPost = posts[0];
  const restPosts = posts.slice(1);

  return (
    <Flex as="section" aria-label="Blog" w="100%" flexDirection="column" alignItems="center">
      <Heading size={{ base: 'lg', md: '4xl' }} fontWeight="900" mb={2} as="h2">
        {t`v2.blog.title`}
      </Heading>
      <Text
        mt={4}
        fontWeight={600}
        fontSize="xl"
        alignSelf="flex-start"
        display={{ base: 'none', lg: 'block' }}
      >
        {t`blog.latestArticles`}
      </Text>

      {heroPost && (
        <Box w="100%" mt={6}>
          <BlogHeroPost {...heroPost} />
        </Box>
      )}

      {restPosts.length > 0 && (
        <Box
          display="grid"
          gridTemplateColumns={{
            base: '1fr',
            md: 'repeat(2, 1fr)',
          }}
          gridGap={5}
          w="100%"
        >
          {restPosts.map((post) => (
            <article key={post.id}>
              <BlogPostPreview {...post} />
            </article>
          ))}
        </Box>
      )}

      <Button variant="outline" colorPalette="gray" mt={8} mx="auto" asChild>
        <Link to="/{-$locale}/blog">{t`blog.viewAll`}</Link>
      </Button>
    </Flex>
  );
};
